module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/152ycy8/tc-custom/9781685626006.jpg?1705766047943",
      "alt": "This image is the cover for the book Man, God, Religion, and State"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Man, God, Religion, and State\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Man, God, Religion, and State,")])]), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v(" is a reflection on our physical, philosophical, and political, past, present, and possible future. This book may challenge the religious views of some readers, but it is not my intention to cause offence to any religious believer. We are all living in a time of anxiety and insecurities, which may prevent us from embracing our humanity. But we should never allow either the pain and sorrow of the past or the threats and fears of the present to obscure our vision of what is just and truthful. Our present socioeconomic relationships are based on injustice and falsehood, which is unsustainable. We must therefore adjust our level and rates of consumption before we cross the line of no-return. In this sense, "), _c('em', [_vm._v("Man, God, Religion, and State")]), _vm._v(" is a warning to us all.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Desmond Clarke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("I arrived in Britain in 1967 to join my mother and stepfather at the age of 14. After leaving school at 16, I spent three years in the British Army. After leaving the army, I worked as a truck driver for many years, until 1992 when I returned to academic studies. In 1997 I achieved a 2:1 (Hons.) degree from Luton University, followed by a post-graduate Diploma and a Masters’ degree from De Montfort University in 2004. My first book, "), _c('em', [_vm._v("Stolen Inheritance")]), _vm._v(", was published in 2019, after many years of research. "), _c('em', [_vm._v("Man, God, Religion, and State")]), _vm._v(" is my second publication and I hope readers will find it stimulating and enjoyable.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0